export default "__VITE_ASSET__DYtXnHvT__"